import { AccountTypeSelection } from '@components/RouteComponents'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/accountTypeSelection')({
  component: AccountTypeSelection,
})
